import React, {useEffect, useRef, useState} from 'react';
import './AiChats.scss';
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";
import MessageBlock from "../MessageBlock/MessageBlock";
import ChatsList from "../ChatsList/ChatsList";
import SearchBlock from "../SearchBlock/SearchBlock";
import {useSelector} from "react-redux";
import {getHeaderHeight} from "../../../../utils/helperFunctions";
import {Text} from "../../../../modules";

export const TABS = {
	MESSAGE: 0,
	SEARCH: 1
}
const SUB_HEADER_HEIGHT = 175;

const AiChats = (props) => {
    const {t} = useTranslation();
    const location = useLocation();
    const {openUserModal,isOpenPopover} = props;
    const [activeTab, setActiveTab] = useState(TABS.MESSAGE);
    const [headerHeight, setHeaderHeight] = useState(0);
    const videoActiveTab = useSelector(state => state.videos?.videoActiveTab);
    const checkVideoPage = (location.pathname || '').includes('/dashboard/videos/video');
    const isCheck = checkVideoPage && videoActiveTab === 1;
    const isAiAgents = (location.pathname || '').includes('/copilot');
    const [isOpenSidePanel, setIsOpenSidePanel] = useState(isAiAgents);
    const isFullWidth = useSelector(state => state.utils.isFullWidth);

    useEffect(()=>{
        setHeaderHeight(getHeaderHeight());
        if(checkVideoPage && videoActiveTab === 1){
            setHeaderHeight(205)
        }else{
            setHeaderHeight(getHeaderHeight() + 45)
        }
    },[videoActiveTab])

    const testRef = useRef(null);
    const rect = testRef.current?.getBoundingClientRect();

    return (
        <div className="ai-chats"
             style={{
                 height: `calc(100vh - ${headerHeight + (isAiAgents ? 68 : 0)}px`,
                 marginLeft: isCheck ? 20 : 0
        }}
        >
            <div className="ai-chats__container">
                <div
                    style={{
                        width: isAiAgents ? `${window.innerWidth > 1700 ? '480px' : '300px'}` : isOpenSidePanel ? 360 : 0,
                        left: isOpenSidePanel ? `calc(${rect?.left}px - ${window.innerWidth > 1700 ? '600px' : isFullWidth ? '550px' : '420px'})` : '33%'
                }}
                    className="ai-chats__left-side"
                >
                    <ChatsList/>
                </div>
                <div
                    className="ai-chats__right-side"
                    ref={testRef}
                    onClick={() => {
                        if (isOpenSidePanel && !isAiAgents) setIsOpenSidePanel(false)
                    }}
                >
                    <div className="chat" >
                        {activeTab === TABS.SEARCH ?
                            <div className={'clean-chat'}>
                                <Text className="clean-chat--title" size="f16" font="medium">{t('input_search')}</Text>
                            </div>
                            :null}
                        {activeTab === TABS.MESSAGE ?
                            <>
                                <MessageBlock
                                	activeTab={activeTab}
                                	isOpenPopover={isOpenPopover}
                                    isOpenSidePanel={isOpenSidePanel}
                                	setActiveTab={setActiveTab}
                                    onClickBurger={() => setIsOpenSidePanel(!isOpenSidePanel)}
                                    containerHeight={headerHeight}
                                />
                            </>
                            : null}
                        {activeTab === TABS.SEARCH ?
                            <SearchBlock
                                activeTab={activeTab}
                                openUserModal={openUserModal}
                                setActiveTab={setActiveTab}
                                containerHeight={headerHeight}
                            />
                            : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AiChats;